import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  IconButton,
  FormHelperText,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

export const bank_fields = [
  {
    label: "Bank Name",
    name: "iban",
    type: "text",
    shrink: true,
    maxLength: 40,
    required: (formData) => formData.acquirer.iso === "True",
    helperText: "Name of the bank",
  },
  {
    label: "Bank Address",
    name: "address",
    type: "text",
    shrink: true,
    maxLength: 32,
    required: (formData) => formData.acquirer.iso === "True",
    helperText: "Physical address of the bank branch",
  },
  {
    label: "Account Number",
    name: "account_number",
    type: "text",
    shrink: true,
    maxLength: 18,
    required: (formData) => formData.acquirer.iso === "True",
    helperText: "Merchant's bank account number",
  },
  {
    label: "Routing Number",
    name: "routing_number",
    type: "text",
    shrink: true,
    maxLength: 9,
    required: (formData) => formData.acquirer.iso === "True",
    helperText: "ABA routing number (US) or sort code (UK)",
  },
];

const BankFields = ({
  formData,
  handleInputChange,
  submittedSteps,
  invalidFields,
}) => {
  return (
    <>
      {bank_fields.map((field) => {
        const isRequired =
          typeof field.required === "function"
            ? field.required(formData)
            : field.required;

        const fieldId = `bank.${field.name}`;
        const isError =
          invalidFields?.includes(fieldId) ||
          (submittedSteps.has("bank") &&
            isRequired &&
            !formData.bank[field.name]);

        return (
          <Grid item xs={12} sm={3} key={field.name}>
            {field.type === "select" ? (
              <FormControl fullWidth required={isRequired} error={isError}>
                <InputLabel
                  id={`${field.name}-label`}
                  sx={{
                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                      fontSize: "1.2rem",
                    },
                  }}
                >
                  {field.label}
                  {field.helperText && (
                    <Tooltip title={field.helperText} arrow>
                      <IconButton
                        size="small"
                        sx={{ padding: 0, marginLeft: "8px" }}
                      >
                        <InfoIcon color="primary" fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </InputLabel>
                <Select
                  labelId={`${field.name}-label`}
                  name={field.name}
                  label={field.label}
                  value={formData.bank[field.name] || ""}
                  onChange={handleInputChange}
                >
                  {field.options &&
                    field.options.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                </Select>
                {isError && (
                  <FormHelperText error>This field is required</FormHelperText>
                )}
              </FormControl>
            ) : (
              <TextField
                label={
                  <>
                    {field.label}
                    {field.helperText && (
                      <Tooltip title={field.helperText} arrow>
                        <IconButton
                          size="small"
                          sx={{ padding: 0, marginLeft: "4px" }}
                        >
                          <InfoIcon color="primary" fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                }
                name={field.name}
                value={formData.bank[field.name] || ""}
                onChange={handleInputChange}
                InputLabelProps={{
                  shrink: field.shrink,
                  sx: {
                    "& .MuiFormLabel-asterisk": {
                      color: "red",
                      fontSize: "1.2rem",
                    },
                  },
                }}
                inputProps={{ maxLength: field.maxLength }}
                required={isRequired}
                error={isError}
                helperText={isError ? "This field is required" : ""}
                fullWidth
              />
            )}
          </Grid>
        );
      })}
    </>
  );
};

export default BankFields;
